import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";

export const features = [
    {
        title: "Grow admissions by up to Rs. 2.5 crores",
        cName: "text-sm font-medium"
    },
    {
        title: "5 Lakhs worth of AI tools completely free of cost",
        cName: "text-sm font-medium"
    },
    {
        title: "Get 20 AI experts who work 24/7 365 days for you",
        cName: "text-sm font-medium"
    },
    {
        title: "Increase reach by up to 1 lakh new parents",
        cName: "text-sm font-medium"
    },
    {
        title: "Improve parent communication automatically",
        cName: "text-sm font-medium"
    },
    {
        title: "Boost student learning through WhatsApp",
        cName: "text-sm font-medium"
    },
    {
        title: "Reduce admin workload using AI systems",
        cName: "text-sm font-medium"
    },
    {
        title: "Save money and staff time",
        cName: "text-sm font-medium"
    },
    {
        title: "Activate complete Soomuch.ai suite in under 10 mins",
        cName: "text-sm font-medium"
    },
    {
        title: "Only onboarding .1% of all school per state",
        cName: "text-sm font-medium"
    }
];


export default function WhyYouShouldAttend() {

    return (
        <Box
            badge={"results"}
            title={"Why You Should Attend"}
            description={"Running a school is not easy. Between parents, teachers, and daily management, time is always short. In this short 30-minute live personalised webinar, you’ll see how schools across India are using AI tools to:"}
            leftBlock={
                features.map((member, index) => <MarktingCard key={"WhyYouShouldAttend" + index} member={member} />)
            }
        />
    );
}